import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, ControlLabel } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';

import isRequiredIf from '../../modules/react-conditional-required';
import I18n from 'i18n-react';
import FlightCompanyLogo from '../flightCompanyLogo/FlightCompanyLogo';
import FlightGridDetails from '../flightGridDetails/FlightGridDetails';
import FlightClassTypePrice from '../flightClassTypePrice/FlightClassTypePrice';
import _ from 'lodash';

import './FlightWithConnectionLine.css';
import Details from '../../flightSelection/details/Details';
import EventEmitter from '../../modules/event-emitter/EventEmitter';
import Listener from '../../../const/Listener';
import FlightDetailsModal from '../flightDetailsModal/FlightDetailsModal';

bootstrapUtils.addStyle(Button, 'alter-search');

const POINTS = 'POINTS';
const ADULT = 'ADULT';
const ECONOMY = 'ECONOMY';
const BUSINESS = 'BUSINESS';

const propTypes = {
  id: PropTypes.string.isRequired,
  hasEmpty: PropTypes.bool,
  flightNumber: isRequiredIf(PropTypes.number, props => !props.hasEmpty),
  operatingCarriers: isRequiredIf(PropTypes.array, props => !props.hasEmpty),
  connections: PropTypes.number,
  throughFlights: PropTypes.number,
  hasExchangeAirport: PropTypes.bool,
  elapsedFlightTime: PropTypes.string,
  toogleElapsedFlightTime: PropTypes.bool,
  toggleDetailsModal: PropTypes.bool,
  isDeparture: PropTypes.bool,
  classType: PropTypes.string,
  price: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      passenger: PropTypes.string,
      value: PropTypes.number,
      currency: PropTypes.string,
      isAvailable: PropTypes.bool
    })
  ),
  baggage: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      quantity: PropTypes.number,
      weight: PropTypes.number
    })
  ),
  departureFlight: PropTypes.shape({
    time: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    plusDays: PropTypes.number,
    airportSign: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    airportName: isRequiredIf(PropTypes.string, props => !props.hasEmpty)
  }),
  arrivalFlight: PropTypes.shape({
    time: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    plusDays: PropTypes.number,
    airportSign: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    airportName: isRequiredIf(PropTypes.string, props => !props.hasEmpty)
  }),
  flightGroup: PropTypes.array,
  fareDeparture: PropTypes.object,
  callbackSelectEconomy: PropTypes.func,
  callbackSelectBusiness: PropTypes.func,
  callbackAlterSearch: PropTypes.func,
  manyDepartureFlightOptions: PropTypes.bool,
  filterCabinCategory: PropTypes.string.isRequired,
  featureShowModalSelectionFlightsToggle: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool,
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      points: PropTypes.number,
      amount: PropTypes.number,
      order: PropTypes.number,
      isDefault: PropTypes.bool
    })
  ),
  flight: PropTypes.object
};

const defaultProps = {
  isDeparture: true,
  hasEmpty: false,
  flightNumber: null,
  operatingCarriers: [],
  connections: null,
  throughFlights: null,
  hasExchangeAirport: false,
  elapsedFlightTime: '',
  toogleElapsedFlightTime: false,
  toggleDetailsModal: false,
  classType: null,
  price: [],
  departureFlight: {
    time: '',
    plusDays: null,
    airportSign: '',
    airportName: ''
  },
  arrivalFlight: {
    time: '',
    plusDays: null,
    airportSign: '',
    airportName: ''
  },
  manyDepartureFlightOptions: false,
  featureFlightsGridCabinTypeToggle: false,
  featureShowModalSelectionFlightsToggle: false,
  ranges: [],
  flight: null
};

class FlightWithConnectionLine extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetailsModal: false,
      featureShowModalSelectionFlightsToggle: props.featureShowModalSelectionFlightsToggle,
      selectFlight: null
    };
  }

  componentWillMount() {
    const prices = _.chain(this.props.price)
      .filter(price => price.currency === POINTS && price.passenger === ADULT)
      .value();

    const economyPrice = _.filter(prices, price => price.category === ECONOMY)[0];
    const businessPrice = _.filter(prices, price => price.category === BUSINESS)[0];
    const rangeDefault = _.filter(this.props.ranges, range => range.isDefault)[0];

    this.setState({
      economyPrice: economyPrice ? economyPrice : { isAvailable: false },
      businessPrice: businessPrice ? businessPrice : { isAvailable: false },
      rangeDefault: rangeDefault
    });
    if (this.props.hasEmpty) {
      EventEmitter.emitEvent(Listener.LOADED_AVAILABILITY, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    let featureShowModalSelectionFlightsToggle = nextProps.featureShowModalSelectionFlightsToggle;
    if (
      featureShowModalSelectionFlightsToggle !== this.props.featureShowModalSelectionFlightsToggle
    ) {
      this.setState({
        featureShowModalSelectionFlightsToggle: featureShowModalSelectionFlightsToggle
      });
    }
  }

  callbackShowDetailsModal = () => {
    this.setState({
      showDetailsModal: true,
      selectFlight: null
    });
  };

  closeDetailsModal = () => {
    this.setState({ showDetailsModal: false });
  };

  selectDetailsModal = (filterCabinCategory, value, rangePointsPlusMoney) => {    
    this.setState({ showDetailsModal: false });
    if (filterCabinCategory == 'ECONOMY') {
      this.props.callbackSelectEconomy(value, rangePointsPlusMoney);
    } else {
      this.props.callbackSelectBusiness(value, rangePointsPlusMoney);
    }
  };

  onSelectFlight = value => {
    if (this.state.featureShowModalSelectionFlightsToggle) {
      this.setState({
        showDetailsModal: true,
        selectFlight: (rangePointsPlusMoney) => this.selectDetailsModal(this.props.filterCabinCategory, value,rangePointsPlusMoney)
      });
    } else {
      if (this.props.filterCabinCategory == 'ECONOMY') {
        this.props.callbackSelectEconomy(value);
      } else {
        this.props.callbackSelectBusiness(value);
      }
    }
  };

  renderModal() {
    if (this.props.toggleDetailsModal) {      
      return (
        <FlightDetailsModal
          id={`modalFlightDetails-${this.props.flightNumber}`}
          close={this.closeDetailsModal}
          show={this.state.showDetailsModal}
          flightGroup={this.props.flightGroup}
          fareDeparture={this.props.fareDeparture}
          isDeparture={this.props.isDeparture}
          baggage={this.props.baggage}
          classType={this.props.price[0]['classType']}
          ref={c => (this.flightDetailsModal = c)}
          cabinCategory={this.props.filterCabinCategory}
          featureShowModalSelectionFlightsToggle={this.state.featureShowModalSelectionFlightsToggle}
          onSelect={this.state.selectFlight}
          isCallcenterEnabled={this.props.isCallcenterEnabled}
          flight={this.props.flight}
          prices={this.props.price}
        />
      );
    } else {
      return (
        <Details
          id={`modalDetails-${this.props.flightNumber}`}
          close={this.closeDetailsModal}
          show={this.state.showDetailsModal}
          flights={this.props.flightGroup}
          ref={c => (this.flightDetailsModal = c)}
        />
      );
    }
  }

  renderPrice() {
    let component = (
      <Row className="container-fluid price-row">
        <Col md={6} xs={6} className="text-center price-economy-col">
          <Row>
            <Col md={12}>
              <FlightClassTypePrice
                id="selectEconomy"
                onClick={this.props.callbackSelectEconomy}
                value={this.state.economyPrice.value}
                isAvailable={this.state.economyPrice.isAvailable}
                ref={c => {
                  this.selectEconomy = c;
                }}
                classType={this.props.price[0]['classType']}
                rangeDefault={this.state.rangeDefault}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6} xs={6} className="text-center price-business-col">
          <Row>
            <Col md={12}>
              <FlightClassTypePrice
                id="selectBusiness"
                onClick={this.props.callbackSelectBusiness}
                value={this.state.businessPrice.value}
                isAvailable={this.state.businessPrice.isAvailable}
                ref={c => {
                  this.selectBusiness = c;
                }}
                classType={this.props.price[0]['classType']}
                rangeDefault={this.state.rangeDefault}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );


      const isEconomy = this.props.filterCabinCategory == 'ECONOMY';
      component = (
        <Row className="container-fluid price-row FlightWithConnectionLine__price">
          <Col md={12} xs={12} className="text-center price-economy-col">
            <Row>
              <Col md={12}>
                <FlightClassTypePrice
                  id={`select${isEconomy ? 'Economy' : 'Business'}`}
                  onClick={this.onSelectFlight}
                  value={isEconomy ? this.state.economyPrice.value : this.state.businessPrice.value}
                  isAvailable={
                    isEconomy
                      ? this.state.economyPrice.isAvailable
                      : this.state.businessPrice.isAvailable
                  }
                  classType={this.props.price[0]['classType']}
                  rangeDefault={this.state.rangeDefault}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      );


    return component;
  }

  renderResult() {
    return (
      <Row className="vertical-middle-row">
        <Col
          md={3}
          xs={12}
          className="vertical-middle-col">
          <FlightCompanyLogo id="flightLogo" flightGroup={this.props.flightGroup} />
        </Col>
        <Col
          md={6}
          xs={12}
          className="vertical-middle-col">
          <FlightGridDetails
            id="flightDetails"
            flightNumber={this.props.flightNumber}
            flightConnections={this.props.connections}
            throughFlights={this.props.throughFlights}
            hasAirportChange={this.props.hasExchangeAirport}
            operatingCarriers={this.props.operatingCarriers}
            departureFlight={this.props.departureFlight}
            arrivalFlight={this.props.arrivalFlight}
            flightGroup={this.props.flightGroup}
            elapsedFlightTime={this.props.elapsedFlightTime}
            toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
            openFlightDetails={this.callbackShowDetailsModal}
            ref={c => {
              this.flightDetails = c;
            }}
          />
        </Col>
        <Col
          md={3}
          xs={12}
          className="vertical-middle-col">
          {this.renderPrice()}
          <Row>
            <Col smHidden mdHidden lgHidden md={12} xs={12} className="detailsTextCol-mobile">
              <ControlLabel
                id={`btnDetailsModalF-${this.props.flightNumber}`}
                onClick={this.callbackShowDetailsModal}
                className="connectionText btnDetailsModal FlightGridDetailsContainer__detailsContainer">
                <span>{I18n.translate('components.flightDetails.detailsBtn')}</span>
              </ControlLabel>
            </Col>
          </Row>
        </Col>
        {this.renderModal()}
      </Row>
    );
  }

  renderButtonAlterSearch() {
    if (!this.props.manyDepartureFlightOptions) {
      return (
        <Button
          id="btnAlterSearch"
          bsStyle="alter-search"
          onClick={this.props.callbackAlterSearch}
          ref={c => {
            this.alterSearch = c;
          }}>
          {I18n.translate('components.flight.alterSearch')}
        </Button>
      );
    }
  }

  renderNoResult() {
    let noResultMessage = '';
    if (this.props.manyDepartureFlightOptions) {
      noResultMessage = I18n.translate('components.flight.resultNotFoundChangeSelection');
    } else {
      noResultMessage = I18n.translate('components.flight.resultNotFound');
    }

    return (
      <Row className="container-not-found">
        <Col>
          <ControlLabel id="lblResultNotFound" className="message-not-found">
            {noResultMessage}
          </ControlLabel>
          {this.renderButtonAlterSearch()}
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div
        id={`componentFlight-${this.props.id}`}
        className="FlightWithConnectionLine componentFlight">
        {this.props.hasEmpty ? this.renderNoResult() : this.renderResult()}
      </div>
    );
  }
}

FlightWithConnectionLine.propTypes = propTypes;
FlightWithConnectionLine.defaultProps = defaultProps;

export default FlightWithConnectionLine;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightWithConnectionLine/FlightWithConnectionLine.jsx